module.exports = __webpack_public_path__ + "img/a30wv-8um7p.76d82d76.png";